module.exports = __webpack_public_path__ + "img/Checkmark-Dark.0f8f3c58.svg";